// removed by extract-text-webpack-plugin
module.exports = {"formGroup":"StackedGroup__formGroup","inputGroup":"StackedGroup__inputGroup","subHeader":"StackedGroup__subHeader"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StackedGroup/StackedGroup.scss
// module id = ./src/components/StackedGroup/StackedGroup.scss
// module chunks = 2